import React, { useEffect, useState } from 'react';
import TextAreaComponent from '../TextAreaComponent';
import { Col } from 'reactstrap';
import { t } from 'i18next';
import { getTenantConfig } from '../Util';

const TextArea = (props) => {
    const [isValid, setIsValid] = useState(true);

    const onTextAreaChanged = (e) => {
        const value = e.target.value;

        // if (value) {
        //     setIsValid(true);
        // } else {
        //     setIsValid(false);
        // }
        props.changed(value);
    };

    useEffect(() => {
        if (props.disable && !props.assessmentCompleted) {
            let assmtIdCheck = props?.assessmentData?.assessmentInternalId
                ? getTenantConfig(props?.assessmentData?.assessmentInternalId)?.umoja
                : false;
            !assmtIdCheck && props.changed('');
        }
    }, [props.disable, props.assessmentCompleted]);

    const getPlaceholder = () => {
        let placeholder = props.placeholder || props.questionText || t('enterYourEmail');
        if (props.isMandate) return `${placeholder} *`;
        else {
            return `${placeholder}`;
        }
    };

    return (
        <React.Fragment>
            {props.type === 119 ? (
                <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="pe-0 mt-0">
                    <TextAreaComponent
                        name={props.id}
                        id={props.answerInternalIdentifier}
                        value={props.value}
                        // placeholder={props.placeholder}
                        placeholder={getPlaceholder()}
                        invalid={props.errors?.[props.id]}
                        onChange={onTextAreaChanged}
                        disabled={props.disable}
                        rows={3}
                        onBlur={props.handleOnBlur}
                    />
                </Col>
            ) : (
                <TextAreaComponent
                    name={props.id}
                    id={props.answerInternalIdentifier}
                    value={props.value}
                    placeholder={props.placeholder}
                    invalid={props.errors?.[props.id]}
                    onChange={onTextAreaChanged}
                    disabled={props.disable}
                    rows={3}
                    onBlur={props.handleOnBlur}
                />
            )}
        </React.Fragment>
    );
};

export default TextArea;
